import React, { useState, useEffect } from "react";
import "./SlideShow.scss";

export default function SlideShow(props) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % props.images.length);
    }, 6000); // Troca a imagem a cada 3 segundos

    return () => clearInterval(interval);
  }, [props.images.length]);

  return (
    <div className="slideshow">
      {props.images.map((item, index) => (
        <div
          key={index}
          className={`slideshow-b ${index === currentIndex ? "active" : ""}`}
        >
          <img
            className="slide-imagem"
            src={item.img}
            alt={`Imagem ${index + 1}`}
          />
          <p className="slide-txt">{item.txt}</p>
        </div>
      ))}
      <div className={`slideshow-b2`}>
        {props.images.map((item, index) => (
          <span
            className={`slideshow-alter ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => {
              setCurrentIndex(index);
            }}
          ></span>
        ))}
      </div>
    </div>
  );
}

SlideShow.defaultProps = {
  nome: "",
  icon: "",
  className: "",
  onClick: () => null,
  images: [
    {
      img: "imgs/slides/slide-img1.png",
      txt: "Solução rápida, inovadora e eficaz",
    },
    {
      img: "imgs/slides/slide-img2.png",
      txt: "Melhor tecnologia e maior desempenho",
    },
    {
      img: "imgs/slides/slide-img3.png",
      txt: "Automatização de tarefas e organização",
    },
  ],
};
